import React from "react";
import LegalDoc from "@/components/LegalDoc";
import { PRIVACY, PRIVACY_META } from "@/content/privacyContent";

export default function PrivacyPage() {
  return <LegalDoc meta={PRIVACY_META} blocks={PRIVACY} />;
}
